import React, { useState, useEffect } from 'react'
import NodataImage from '../../../../../images/nodata.png';
import Loader from '../../../../presentationals/Loader/Loader.component';
import { getProductJunctionDetails, UpdateProductNameById, getNbfcList } from '../../AdminActionCreator.component';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { Company_DATA } from '../../../../../layouts/MainTenantconfig';

export default function ProductMainnew() {
    const tenant = useSelector((state)=>state.tenant.activeTenant)
    const [loader, setloader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [editPopup, setEditPopup] = useState({ show: false, data: {} })
    const [APIData, setAPIData] = useState([])
    const [newProductName, setnewProductName] = useState("")
    const [nbfcData, setnbfcData] = useState([]);

    useEffect(() => {
        getProductJunctionDetailsFn()
        getNbfcListFn()
    }, [])

    const getNbfcListFn = () => {
        setloader(true)
        getNbfcList(callback => {
            setloader(false)
            setnbfcData(callback)
        })
    }

    const getProductJunctionDetailsFn = () => {
        // setcurrentPage(1)
        setloader(true)
        getProductJunctionDetails(callback => {
            setloader(false)
            console.log("cal", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setAPIData(callback?.data)
                // setFilteredData(filterFunction(callback?.data, 1))
            } else {
                setAPIData([])
                // setFilteredData([])
            }
        })
    }

    const handleSave = () => {
        if (newProductName != "" && newProductName !== null && newProductName !== undefined) {
            const obj = {
                newProductName: newProductName,
                productId: editPopup?.data?.productId
            }
            setloader(true)
            UpdateProductNameById(obj.productId, obj.newProductName, callback => {
                setloader(false)
                console.log("cal", callback)
                if (callback && callback?.message == "success") {
                    setPopup({ show: true, popupStatus: "Success" })
                    handlebtnclick(false, "")
                } else {
                    setPopup({ show: true, popupStatus: "Failure" })
                }
            })

        } else {
            setPopup({ show: true, popupStatus: "Please Enter Product Name" })
        }
        removePopup()
    }

    const handlebtnclick = (type, data) => {
        setEditPopup({ show: type, data: data })
        if (type == true) {
            setnewProductName(data?.productName || "")
        } else if (type == false) {
            setnewProductName("")
            getProductJunctionDetailsFn()
        }
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }
    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const returnNbfcName = (id) => {
        const data = nbfcData && nbfcData?.length > 0 ? nbfcData?.filter((el) => el.nbfcId == id) : []
        return data?.[0]?.name
    }

    const tableDatacheck = (data) => {
        if (data == null || data == undefined || data == '') {
            return '-'
        } else {
            return data
        }
    }

    const handleDateTime = (d) => {
        if (d == null || d == undefined || d == '') {
            return '-'
        } else {
            const date = new Date(d);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }



    return (
        <>
            {
                loader ?
                    <Loader />
                    : ''}
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''}

            <div className='container' style={{ marginTop: '30px' }}>
                {
                    APIData && Object.keys(APIData)?.length > 0 ?
                        Object.keys(APIData)?.map((value, index) => {
                            return (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                        style={{ borderBottom: '2px solid #fff', background: tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ? 'rgba(0, 108, 103, 0.2)' : "rgba(14, 87, 104, 0.5)" }}
                                    >
                                        <Typography component="span" style={{ fontSize: '16px' }}>
                                            <b> {returnNbfcName(value)}</b>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ height: '400px', overflowY: 'auto', background: tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ? 'rgba(0, 108, 103, 0.2)' : "rgba(14, 87, 104, 0.5)", padding: '16px' }}>
                                        {
                                            APIData[value] && APIData[value]?.length > 0 ?
                                                APIData[value]?.map((data, id) => {
                                                    return (
                                                        <Accordion >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls="panel1-content"
                                                                id="panel1-header"

                                                                style={{ borderBottom: '1px solid #eee', width: '100%' }}
                                                            >
                                                                <Typography component="span" style={{ margin: 'auto', textAlign: 'center', background: '#dbe9ff', borderRadius: '6px', padding: '5px 10px', fontSize: '12px' }}>
                                                                    Product Name -&nbsp;
                                                                    {/* <br /> */}
                                                                    <b>{data?.productName || ""}</b>
                                                                </Typography>
                                                                <Typography component="span" style={{ margin: 'auto', textAlign: 'center', background: '#dbe9ff', borderRadius: '6px', padding: '5px 10px', fontSize: '12px' }}>
                                                                    Loan Utility Id -&nbsp;
                                                                    {/* <br /> */}
                                                                    <b>{data?.loanUtilityId || ""}</b>
                                                                </Typography>
                                                                <Typography component="span" style={{ margin: 'auto', textAlign: 'center', background: '#dbe9ff', borderRadius: '6px', padding: '5px 10px', fontSize: '12px' }}>
                                                                    Processing Fees Id -&nbsp;
                                                                    {/* <br /> */}
                                                                    <b>{data?.processingFeeId || ""}</b>
                                                                </Typography>

                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <div>
                                                                    <div className="overflow-auto">
                                                                        <table className="phocket-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{minWidth:'150px'}}>ROI Reflect Date</th>
                                                                                    <th style={{minWidth:'150px'}}>Previously Affect</th>
                                                                                    <th style={{minWidth:'150px'}}>stamp Duty Charge</th>

                                                                                    <th style={{minWidth:'150px'}}>penalty Amount</th>
                                                                                    <th style={{minWidth:'150px'}}>Normal Interest</th>
                                                                                    <th style={{minWidth:'150px'}}>Min Amount</th>
                                                                                    <th style={{minWidth:'150px'}}>Max Amount</th>
                                                                                    <th style={{minWidth:'150px'}}>No Of EMI's</th>

                                                                                    <th style={{minWidth:'150px'}}>EMI Penalty Interest</th>
                                                                                    <th style={{minWidth:'150px'}}>GST Interest</th>
                                                                                    <th style={{minWidth:'180px'}}>cheque Bounce Charge</th>
                                                                                    <th style={{minWidth:'180px'}}>Mandate Bounce Charge</th>
                                                                                    <th style={{minWidth:'150px'}}>Processing Fee</th>
                                                                                    <th style={{minWidth:'150px'}}>Processing Type</th>
                                                                                    <th style={{minWidth:'150px'}}>Edit</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{padding:'15px'}}>{handleDateTime(data?.loanUtilityDO?.roiReflectDate)}</td>
                                                                                    <td>{data?.loanUtilityDO?.previouslyAffect == true ? 'Yes' : 'No'}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.stampDutyCharge)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.penaltyAmount)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.normalInterest)}</td>

                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.minAmount)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.maxAmount)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.noOfEmi)}</td>


                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.emiPenaltyInterest)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.gstInterest)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.chequeBounceCharge)}</td>
                                                                                    <td>{tableDatacheck(data?.loanUtilityDO?.mandateBounceCharge)}</td>
                                                                                    <td>{tableDatacheck(data?.processingFeeDO?.processingFee)}</td>
                                                                                    <td>{tableDatacheck(data?.processingFeeDO?.processingType)}</td>
                                                                                    <td>
                                                                                        <div className='edits'>
                                                                                            <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true" onClick={() => handlebtnclick(true, data)}></i>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    )
                                                })
                                                : ''}

                                    </AccordionDetails>
                                </Accordion>
                            )
                        })
                        : ''}

                {
                    editPopup?.show ?
                        <div className="background-blur">

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                                <i onClick={() => handlebtnclick(false, "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                <div className="row from-group">
                                    <div className="col-xs-12" style={{ padding: '10px' }}>
                                        <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Add/Update Product Name</h4>
                                    </div>

                                    <div className='row from-group ' style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div className="col-xs-8" style={{ marginTop: '20px' }}>
                                            <input type='text' placeholder='Add Product Name' value={newProductName} onChange={e => setnewProductName(e.target.value)} className='form-control' />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 text-center" style={{ marginTop: '30px' }} >
                                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ''}
            </div>
        </>
    )
}
